import React from 'react';
import './info.css'


const Info =()=>{

return (
<section className="section2">
        <div className="section2-content">
          <div className="section2-item">
            <img src="https://images.unsplash.com/photo-1515378960530-7c0da6231fb1?auto=format&fit=crop&q=80&w=1000&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NHx8dHlwaW5nJTIwb24lMjBsYXB0b3B8ZW58MHx8MHx8fDA%3D" alt="Imag 1" />
            <h2>Explore stunning locations</h2>

          </div>
          <div className="section2-item">
            <img src="https://cf.bstatic.com/xdata/images/hotel/max1024x768/468651990.jpg?k=e642e716b399513c4aac3d4a38e273b6e8420b7df7ba61d4018c3cf9151459c7&o=&hp=1" alt="Imag 2" />
            <h2>Enjoy modern amenities</h2>

          </div>
          <div className="section2-item">
            <img src="https://livinspaces.net/wp-content/uploads/2016/02/magnolia-hills-kitisuru-1.jpg" alt="Image3" />
            <h2>Experience comfort and luxury</h2>

          </div>
        </div>
      </section>
)
}

export default Info;